import LandingPage from "@pages/LandingPage/LandingPage";
import { RootState } from "@store/reducers";
import {
  EnumUserTypes,
  RecruiterApprovalStatus,
  RecruiterTypes,
} from "@utils/constants";
import { useEffect } from "react";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { getPostLoginRoute } from "./routerHelperFunctions";

export function HomeRedirect() {
  const { authenticated, user, loading } = useSelector(
    (state: RootState) => state.auth
  );
  const navigate = useNavigate();

  useEffect(() => {
    if (loading || !authenticated) return;

    const target = getPostLoginRoute(user);
    navigate(target, { replace: true });
  }, [loading, authenticated, user, navigate]);

  if (loading) {
    return <div>Loading...</div>;
  }

  if (!authenticated) {
    return <LandingPage />;
  }

  return null;
}
